import React from 'react'
import { func } from 'prop-types'

import HeadEditor from './HeadEditor'

import style from './style'

function typeAEditor (props) {
  const {
    saveEditing,
    cancelEditing,
    routeToNewDoc,
    routeToCopyDoc,
    spliter,
    ...rest,
  } = props

  return (
    <div>
      <div className={style.screen}>
        <h3 className={style.pageTitle}>A類商品</h3>
        <HeadEditor {...{ spliter, ...rest }} style={style} />
        <div className={style['button-container']}>
          <button className="btn btn-primary btn-lg" onClick={saveEditing} >儲存</button>
          <button className="btn btn-primary btn-lg" onClick={routeToNewDoc} >儲存新增</button>
          <button className="btn btn-primary btn-lg" onClick={routeToCopyDoc} >複製新增</button>
          <button className="btn btn-default btn-lg" onClick={cancelEditing} >取消</button>
        </div>
      </div>
    </div>
  )
}

typeAEditor.propTypes = {
  saveEditing: func.isRequired,
  cancelEditing: func.isRequired,
  routeToNewDoc: func.isRequired,
  routeToCopyDoc: func.isRequired,
  spliter: func.isRequired,
}

export default typeAEditor



// WEBPACK FOOTER //
// ./src/components/products/productsA/Editor.jsx